import { BREEDS, GENDERS } from "@/lib/horseOptions";

// [application horse key, label, scan field]
export const REG_ROWS = [
  ["registered_name", "Registered Horse Name", "registered_name"], ["registered_number", "Registration Number", "registration_number"],
  ["date_of_birth", "Date of Birth", "date_of_birth"], ["age", "Year Born", "year_born"], ["gender", "Gender", "gender"],
  ["color", "Colour", "colour"], ["breed", "Breed / Registry", "breed_registry"], ["sire", "Sire", "sire"], ["dam", "Dam", "dam"],
];

const genderKey = (v) => (GENDERS.find(([k]) => k === String(v || "").toLowerCase()) || [""])[0];
const breedKey = (v) => (v ? (BREEDS.find(([, l]) => l.toUpperCase().includes(`(${String(v).toUpperCase()})`)) || [""])[0] : "");

// Scan suggestion mapped onto application horse keys (blank = not read).
export function fromScan(scan) {
  const f = scan?.fields || {};
  return Object.fromEntries(REG_ROWS.map(([k, , s]) => [k, k === "gender" ? genderKey(f[s]) : k === "breed" ? breedKey(f[s]) : f[s] || ""]));
}

export const displayReg = (k, v) => {
  if (!v) return "";
  if (k === "gender") return (GENDERS.find(([x]) => x === v) || [, v])[1];
  if (k === "breed") return (BREEDS.find(([x]) => x === v) || [, v])[1];
  return v;
};

export const latestScan = (papers) => papers.filter((m) => m.scan?.status === "recognized").sort((a, b) => (b.scan.scanned_at || "").localeCompare(a.scan.scanned_at || ""))[0]?.scan;
